import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DomainServices, UserServices } from '@/services/apis';

interface StateType {
  domains?: any[];
  loading?: boolean;
  error?: boolean;
  errorMessage?: string;
  totalRecords?: number;
  domainUsers: any[];
  totalUsersCount?: number;
  newlyCreatedDomain?: any;
}

const initialState: StateType = {
  domains: [],
  loading: true,
  error: false,
  errorMessage: '',
  totalRecords: 0,
  domainUsers: [],
  totalUsersCount: 0,
  newlyCreatedDomain: {},
};

export const updateNewDomain = createAsyncThunk('domain/updateNewDomain', async (newDomain: any) => {
  return newDomain;
});

export const fetchDomainAdmins = createAsyncThunk(
  'users/fetchDomainAdmins',
  async ({
    pagination,
    userName,
    domainName,
    roleType,
    roleName,
    groupId,
    roleId,
    organizationId,
    appName,
    appType,
    organizationName,
  }: any) => {
    const response = await UserServices.fetchUsers(
      pagination.page + 1,
      pagination.rowsPerPage,
      userName,
      domainName,
      roleType,
      roleName,
      groupId,
      roleId,
      organizationName,
      organizationId,
      appName,
      appType,
    );
    return response;
  },
);

export const fetchAllDomain = createAsyncThunk(
  'domain/fetchAllDomain',
  async ({ page, rowsPerPage, searchDomainTerm }: any) => {
    const response = await DomainServices.fetchDomains({
      pageNumber: page,
      pageSize: rowsPerPage,
      domainName: searchDomainTerm,
    });

    return response;
  },
);

export const fetchDomainDetails = createAsyncThunk('domain/fetchDomainDetails', async ({ domainName }: any) => {
  const response = await DomainServices.fetchDomains({
    domainName,
  });

  return response;
});

export const createNewDomain = createAsyncThunk('domain/createNewDomain', async (domainData: any) => {
  const response = await DomainServices.createDomain(domainData, domainData?.dom_name);
  return response;
});

export const updateDomain = createAsyncThunk('domain/updateDomain', async (domainData: any) => {
  const { domainId, ...finalData } = domainData;
  const data = await DomainServices.updateDomain(finalData, domainId);
  return data;
});

export const deleteDomain = createAsyncThunk('domain/deleteDomain', async (domainId: any) => {
  const data = await DomainServices.deleteDomain(domainId);
  return data;
});

export const downloadDomain = createAsyncThunk('domain/downloadDomain', async () => {
  const response = await DomainServices.downloadDomain();
  return response;
});

export const DomainSlice = createSlice({
  name: 'domain',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createNewDomain.pending, (state) => {
      return { ...state, newlyCreatedDomain: {}, loading: true };
    });
    builder.addCase(createNewDomain.fulfilled, (state, { payload }) => {
      return { ...state, newlyCreatedDomain: payload?.result, loading: false };
    });
    builder.addCase(createNewDomain.rejected, (state) => {});
    builder.addCase(fetchAllDomain.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(fetchAllDomain.fulfilled, (state, { payload }) => {
      return { ...state, domains: payload?.result?.domains, totalRecords: payload?.totalRecords, loading: false };
    });
    builder.addCase(fetchAllDomain.rejected, (state) => {
      return { ...state, domains: [], totalRecords: 0, loading: false };
    });
    builder.addCase(fetchDomainAdmins.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(fetchDomainAdmins.fulfilled, (state, { payload }) => {
      const finalUsers = payload?.result?.users?.map((item: any) => {
        const role: any = [];
        item.organizations.map((org: any) =>
          org.application.map((app: any) => {
            app.role.map((userrole: any) => {
              role.push({ ...userrole, app_uuid: app.id, app_name: app.name });
            });
          }),
        );
        return {
          ...item,
          roles: role,
        };
      });
      return { ...state, domainUsers: finalUsers || [], totalUsersCount: payload?.totalRecords, loading: false };
    });
    builder.addCase(fetchDomainAdmins.rejected, (state, { payload }) => {
      return { ...state, domainUsers: [], totalUsersCount: 0, loading: false };
    });
  },
});

export const domainSelector = (state: any) => state.domain;

export default DomainSlice.reducer;
